import templateUrl from './reset-password.html';
import find from 'lodash/find';

export const resetPasswordComponent = {

    bindings: {
        isTokenValid: '<',
        token: '<'
    },

    templateUrl,

    controller: class ResetPasswordComponent {
        constructor(AuthService, $timeout, $state, toastr) {
            'ngInject';

            this.authService = AuthService;
            this.$timeout = $timeout;
            this.$state = $state;
            this.toastr = toastr;
        }

        $onInit() {
            this.showResetForm = true;

            if (!this.isTokenValid) {
                this.showResetForm = false;
                this.showExpireToken = true;
                this.showThankingMsg = false;
            }
        }

        confirmReset() {
            this.showResetForm = true;
            this.showConfirmReset = false;
        }

        resetPassword() {
            if (this.details.newPassword !== this.details.confirmPassword) {
                this.mismatchPswd = true;
            } else {
                this.authService.resetPassword(this.token, this.details).then((details) => {
                    this.showResetForm = false;
                    this.showThankingMsg = true;
                }).catch((error) => {
                    this.toastr.error(error);
                });
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/auth/reset-password/reset-password.component.js